export const initialErrorState = {
 name: {
   hasError: false,
   error: "",
 },
 phone: {
   hasError: false,
   error: "",
 },
 email: {
   hasError: false,
   error: "",
 },
 house: {
   hasError: false,
   error: "",
 },
 area: {
   hasError: false,
   error: "",
 },
 pinCode: {
   hasError: false,
   error: "",
 },
 countryToShip: {
   hasError: false,
   error: "",
 },
 city: {
   hasError: false,
   error: "",
 },
 state: {
   hasError: false,
   error: "",
 },
};